import { FormatService } from 'services/FormatService'

const style = {
  align: 'center',
  valign: 'center',
  fill: '#ffffff',
  font: 'Aeroport',
  fontFamily: 'Aeroport',
  fontSize: 40,
  fontStyle: 'normal',
  fontWeight: 'normal',
  wordWrap: true,
  wordWrapWidth: 110.335,
}

export function buttonBetText({ betName, buttonWidth, textPosY, textPosX }) {
  const bets = game.models.BetModel.getList()
  const payload = parseInt(betName.split('-')[1])
  const value = FormatService.currency(bets[payload], false)

  return createText(betName, value, buttonWidth, textPosY, textPosX)
}

function createText(betName, value, buttonWidth, textPosY, textPosX) {
  const text = new PIXI.Text(value, style)
  text.name = betName.split('-')[0]
  text.anchor.set(0.5, 0.5)
  text.x = textPosX
  text.y = textPosY

  const checkTextFit = () => {
    if (buttonWidth < text.width) {
      text.style.fontSize = text.style.fontSize * 0.8
      checkTextFit()
    }
  }
  checkTextFit()

  return text
}
